// Utils
import { checkIsLoggedInUserAdminUser } from "../../../common-utils/user-utils/userUtils";

// Components
import DashboardCard from "../../../components/dashboard-card/DashboardCard";
import PageHeader from "../../../mavin/components/page-header/PageHeader";

// Sections
import CampaignsTable from "./CampaignsTable";

// Page functions
function getCardInfo(isAdminUser) {
  // conditionally showing manage buyers and configs cards
  const manageBuyerAndConfigCardClass = !isAdminUser ? "d-none" : "";

  return [
    {
      title: "Create a Campaign",
      content: "Manage your campaign end to end from creation and analysis.",
      CTALabel: "Create A Campaign",
      CTALink: "/campaign/planning",
    },
    {
      title: "Create a Pure DOOH Campaign",
      content:
        "Analyze individual DOOH media sites and their estimated impressions.",
      CTALabel: "Create A Campaign",
      CTALink: "/campaign/planning?_isPureDooh=true",
    },
    {
      title: "Manage Buyers",
      content: "Create and manage buyers and it's users for the organization.",
      CTALabel: "Manage Buyers",
      CTALink: "/org/buyer/list",
      className: manageBuyerAndConfigCardClass,
    },
    {
      title: "Manage Configurations",
      content: "Create and manage configurations data for the organization.",
      CTALabel: "Manage Configs",
      CTALink: "/city-config/media-types",
      className: manageBuyerAndConfigCardClass,
    },
  ];
}

// Page Components
function HomeCardsSection() {
  // checking the USER is Admin or not
  const isAdminUser = checkIsLoggedInUserAdminUser();

  // cards data
  const cardsInfo = getCardInfo(isAdminUser);

  return (
    <>
      <div className="justify-content-left row">
        {cardsInfo.map((card, i) => {
          return (
            <DashboardCard
              key={i}
              i={i}
              card={card}
              className={card.className}
            />
          );
        })}
      </div>
      <hr className="divider" />
    </>
  );
}

/**
 * Page
 */
export default function HomePage() {
  // page actions
  const pageActions = (
    <p className="pt-2">Version : {process.env.REACT_APP_VERSION}</p>
  );

  return (
    <div className="content-wrapper bg-alt min-vh-100">
      <PageHeader
        title={"Dashboard"}
        border={false}
        shadow={false}
        actions={pageActions}
      />

      <div className="page-content">
        <HomeCardsSection />
        <CampaignsTable />
      </div>
    </div>
  );
}
